const RECONNECTING_SCREEN_WAIT_TIME_IN_SECONDS: number =
  Number(process.env.REACT_APP_RECONNECTING_SCREEN_WAIT_TIME_IN_SECONDS) || 600

const RECONNECTING_SCREEN_RESET_TIME_IN_MILLISECONDS: number =
  Number(
    process.env.REACT_APP_RECONNECTING_SCREEN_RESET_TIME_IN_MILLISECONDS
  ) || 5000

export {
  RECONNECTING_SCREEN_WAIT_TIME_IN_SECONDS,
  RECONNECTING_SCREEN_RESET_TIME_IN_MILLISECONDS,
}
